import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Row,
  Input,
} from "reactstrap";
import { AvField, AvForm, AvInput } from "availity-reactstrap-validation";
import PropTypes from "prop-types";
import { showInfoMessage, getDefaultValueForSelect } from "../../../../../helpers/utils";
import FullScreenPreview from "../../../../../components/Common/FullScreenPreview";
import styled from "styled-components";
import PreloaderData from "../../../../../components/PreloaderData";
import CustomSelect from "../../../../../components/Common/CustomSelect";

const LegalEntityInformationForm = ({
  data,
  legalEntityData,
  history,
  addLegalEntity,
  updateLegalEntityProfile,
  legalEntityId,
  loader,
  permissions
}) => {
  const [signDate, setSignDate] = useState(data?.date_of_signature);
  const [expDate, setExpDate] = useState(data?.expiration);
  const [signature, setSignature] = useState(data?.signature);
  const [showTax, setShowTax] = useState(data?.show_tax)
  const [showPreview, setShowPreview] = useState(false);
  const [currencyPreview, setCurrencyPreview] = useState([
    {
      label: 'USD',
      value: 'USD',
    },
    {
      label: 'UAH',
      value: 'UAH',
    }
  ])
  const [mouseOver, setMouseOver] = useState(null);

  useEffect(() => {
    document.addEventListener("click", handleSignature, true);
    return () => {
      document.removeEventListener("click", handleSignature, true);
    };
  }, []);

  useEffect(() => {
    if (data?.date_of_signature) {
      setSignDate(data?.date_of_signature);
    } else if (data?.expiration) {
      setExpDate(data?.expiration);
    }
    if (data?.signature) {
      setSignature(data?.signature);
      // imageUrlToFile(data?.signature);
    }
    if (data?.show_tax) {
      setShowTax(data?.show_tax);
    }
  }, [data]);

  const handleSignature = e => {
    const ids = [
      "signature__preview",
      "signature__preview_image",
      "signature__trash",
    ];
    const path = e.path || (e.composedPath && e.composedPath());
    if (
      path[0] === document.querySelector(`#${ids[0]}`) ||
      path[0] === document.querySelector(`#${ids[1]}`)
    ) {
      setShowPreview(!showPreview);
    } else if (path[0] === document.querySelector(`#${ids[2]}`)) {
      setSignature("remove");
    }
  };

  // const imageUrlToFile = async url => {
  //   let image = {};
  //   fetch(url, {
  //     mode: "no-cors",
  //   })
  //     .then(res => res.blob())
  //     .then(blob => {
  //       let file = new File([blob], "image.png", { type: blob.type });
  //       image = Object.assign(file, {
  //         preview: URL.createObjectURL(file),
  //       });
  //       console.log(image);
  //       setSignature(image);
  //     });
  // };

  const setSignatureImage = file => {
    if (file !== undefined) {
      let file_type = file.name.split(".").pop();
      let file_types = ["PNG", "png"];
      if (file_types.indexOf(file_type) >= 0) {
        let image = Object.assign(file, {
          preview: URL.createObjectURL(file),
        });
        console.log(image)
        setSignature(image);
      } else {
        showInfoMessage("Unavailable format, add image with .png format!");
      }
    }
  };

  const formSubmit = (e, errors, params) => {
    // debugger
    if (errors.length === 0) {
      let data = {};
      let formData = new FormData();
      let legal_entity = {
        contract_number: params.contract_number,
        date_of_signature: signDate,
        expiration: expDate,
        counterparty_name: params.counterparty_name,
        legal_address: params.legal_address,
        postal_address: params.postal_address,
        settlement_account: params.settlement_account,
        correspondent_account: params.correspondent_account,
        bank_name: params.bank_name,
        bank_address: params.bank_address,
        swift: params.swift,
        cpp: params.cpp,
        inn: params.inn,
        ogrn: params.ogrn,
        bic: params.bic,
        okpo: params.okpo,
        signer: params.signer,
        position: params.position,
        tax_type: params.tax_type,
        tax_rate: params.tax_rate,
        type: params.type,
        show_tax: params.checkbox_tax_shown,
        currency: params.currency.value,
      };

      for (const [key, value] of Object.entries(legal_entity)) {
        if (value !== "" && value !== undefined) {
          data[key] = value;
        }
      }

      for (let [key, value] of Object.entries(data)) {
        formData.append(key, value);
      }
      if (legalEntityId) {
        if (signature === "remove") {
          updateLegalEntityProfile(
            legalEntityId,
            formData,
            legalEntityData,
            "remove"
          );
        } else {
          signature?.preview && formData.append("signature", signature);
          updateLegalEntityProfile(
            legalEntityId,
            formData,
            legalEntityData,
            ""
          );
        }
      } else {
        if (signature === "remove") {
          addLegalEntity(formData, legalEntityData);
        } else {
          signature !== undefined && formData.append("signature", signature);
          addLegalEntity(formData, legalEntityData);
        }
      }
      history.push("/legal-entity");
    }
  };

  return (
    <React.Fragment>
      {!loader ? (
        <AvForm
          className="needs-validation fade-in-custom-animate"
          onSubmit={formSubmit}
        >
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-3">Contractor information</h4>
                  <Row className="mt-2">
                    <Col lg="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">Counterparty name:</Label>
                        <AvField
                          name="counterparty_name"
                          placeholder="Counterparty name"
                          value={data?.counterparty_name || ""}
                          type="text"
                          errorMessage="Counterparty name field is required!"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">Legal address:</Label>
                        <AvField
                          name="legal_address"
                          placeholder="Legal address"
                          value={data?.legal_address || ""}
                          type="text"
                          //errorMessage="Legal address field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">Postal address:</Label>
                        <AvField
                          name="postal_address"
                          placeholder="Postal address"
                          value={data?.postal_address || ""}
                          type="text"
                          //errorMessage="Postal address field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">Settlement account:</Label>
                        <AvField
                          name="settlement_account"
                          placeholder="Settlement account"
                          value={data?.settlement_account || ""}
                          type="text"
                          //errorMessage="Settlement account field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">Correspondent account:</Label>
                        <AvField
                          name="correspondent_account"
                          placeholder="Correspondent account"
                          value={data?.correspondent_account || ""}
                          type="text"
                          //errorMessage="Correspondent account field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">Name of bank:</Label>
                        <AvField
                          name="bank_name"
                          placeholder="Bank name"
                          value={data?.bank_name || ""}
                          type="text"
                          //errorMessage="Bank name field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">Bank address:</Label>
                        <AvField
                          name="bank_address"
                          placeholder="Bank address"
                          value={data?.bank_address || ""}
                          type="text"
                          //errorMessage="Bank address field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">SWIFT:</Label>
                        <AvField
                          name="swift"
                          placeholder="SWIFT"
                          value={data?.swift || ""}
                          type="text"
                          //errorMessage="SWIFT field is required!"
                          className="form-control"
                          validate={{
                            minLength: {
                              value: 8,
                              errorMessage:
                                "Please enter at least 8 characters.",
                            },
                            maxLength: {
                              value: 11,
                              errorMessage:
                                "Please enter no more than 11 characters.",
                            },
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">
                          CPP (Classifier of Industrial Enterprises):
                        </Label>
                        <AvField
                          name="cpp"
                          placeholder="CPP"
                          value={data?.cpp || ""}
                          type="text"
                          //errorMessage="CPP field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">
                          INN (Taxpayer Identification Number):
                        </Label>
                        <AvField
                          name="inn"
                          placeholder="INN"
                          value={data?.inn || ""}
                          type="text"
                          //errorMessage="INN field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">
                          OGRN (Principal State Registration Number):
                        </Label>
                        <AvField
                          name="ogrn"
                          placeholder="OGRN"
                          value={data?.ogrn || ""}
                          type="text"
                          //errorMessage="OGRN field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">BIC (Bank Identifier Code):</Label>
                        <AvField
                          name="bic"
                          placeholder="BIC"
                          value={data?.bic || ""}
                          type="text"
                          //errorMessage="BIC field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">
                          OKPO (Classifier of Enterprises and Organizations):
                        </Label>
                        <AvField
                          name="okpo"
                          placeholder="OKPO"
                          value={data?.okpo || ""}
                          type="text"
                          //errorMessage="OKPO field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">Signer:</Label>
                        <AvField
                          name="signer"
                          placeholder="Signer"
                          value={data?.signer || ""}
                          type="text"
                          //errorMessage="Signer field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">Position:</Label>
                        <AvField
                          name="position"
                          placeholder="Position"
                          value={data?.position || ""}
                          type="text"
                          //errorMessage="Position field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                    <Col
                      xl={
                        signature !== undefined && signature !== "remove"
                          ? 4
                          : 6
                      }
                    >
                      <FormGroup className="mb3">
                        <Label htmlFor="">Signature:</Label>
                        <Input
                          type="file"
                          className="form-control"
                          id="inputGroupFile03"
                          aria-describedby="inputGroupFileAddon03"
                          aria-label="Upload"
                          accept="image/png, image/PNG"
                          name="test"
                          onChange={event =>
                            setSignatureImage(event.target.files[0])
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col
                      xl="2"
                      className={` ${signature !== undefined && signature !== "remove"
                        ? "fade-in-custom-animate"
                        : "d-none"
                        }`}
                    >
                      <FormGroup className="mb3">
                        <Preview>
                          <div className={`image__block_signature `}>
                            <div
                              id="signature__preview"
                              className="image__preview_signature"
                            >
                              <img
                                id="signature__preview_image"
                                src={
                                  signature?.preview
                                    ? signature?.preview
                                    : signature
                                }
                              />
                            </div>
                            <div className="image__delete_action">
                              <i
                                id="signature__trash"
                                className="mdi mdi-trash-can d-block font-size-18"
                              />
                            </div>
                          </div>
                        </Preview>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-3">Tax</h4>
                  <Row className="mt-2">
                    <Col lg="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">Tax type:</Label>
                        <AvField
                          name="tax_type"
                          placeholder="Tax type"
                          value={data?.tax_type || ""}
                          type="text"
                          //errorMessage="Tax type field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">Tax rate:</Label>
                        <AvField
                          name="tax_rate"
                          placeholder="Tax rate"
                          value={data?.tax_rate || ""}
                          type="number"
                          //errorMessage="Tax rate field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="">Type:</Label>
                        <AvField
                          name="type"
                          placeholder="Type"
                          value={data?.type || ""}
                          //errorMessage="Type field is required!"
                          className="form-control"
                        //validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="validationCustom02">
                          Currency:
                        </Label>
                        <CustomSelect
                          name="currency"
                          options={currencyPreview}
                          placeholder="Select legal entity..."
                          defaultValue={getDefaultValueForSelect(
                            data?.currency
                          )}
                          classNamePrefix="select2-selection"
                          errorMessage="Currency field is required!"
                          isFormSubmit={false}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <div className="form-check">
                        <AvInput
                          value={!!showTax}
                          defaultChecked={!!showTax}
                          className="form-check-input"
                          type="checkbox"
                          name={'checkbox_tax_shown'}
                          id={'id'}
                        />
                        <Label htmlFor="checkbox_tax_shown">Show TAX</Label>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="justify-content-center">
            {permissions?.["change_innercontractormodel"] && (
              <Col className="col-12" align="right">
                <Button
                  style={{ margin: "25px 0" }}
                  type="submit"
                  color="success"
                >
                  Save changes
                </Button>
              </Col>
            )}
          </Row>
        </AvForm>
      ) : (
        <PreloaderData />
      )}
      <FullScreenPreview
        isOpen={showPreview}
        image={signature}
        trigger={setShowPreview}
      />
    </React.Fragment>
  );
};

const Preview = styled.div`
  display: flex;
  justify-content: space-between;

  .image__block_signature {
    display: flex;
    border: 1px solid #ced4da;
    border-radius: 3px;
    height: 64px;
    transition: 0.5s;
    width: 100%;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    appearance: none;
    border-radius: 0.25rem;

    .image__preview_signature {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 63px;
      transition: 0.5s;
      border-radius: 0.25rem;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;

      img {
        -webkit-transform: translate(0%, 0%);
        transform: translate(0%, 0%) scale(0.7);
        max-width: 100%;
        max-height: 100%;
      }

      i {
        float: right;
      }
      &:hover {
        cursor: pointer;
        background: rgba(0, 0, 0, 0.1);
      }
    }

    .image__delete_action {
      display: flex;
      justify-content: center;
      width: 60px;
      height: 63px;
      vertical-align: middle;
      transition: 0.5s;
      border-left: 1px solid #ced4da;
      i {
        margin: auto;
      }

      &:hover {
        cursor: pointer;
        color: #f46a6a;
      }
    }

  .image__trash_block {
    margin: 23px 0 0 0;
    width: 38px;
    button {
      height: 37px;
    }
  }

  @media (max-width: 1200px) {
    margin: 16px 0 0 0;
  }
`;

LegalEntityInformationForm.propTypes = {
  data: PropTypes.object.isRequired,
  legalEntityData: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  history: PropTypes.object.isRequired,
  addLegalEntity: PropTypes.func.isRequired,
  updateLegalEntityProfile: PropTypes.func,
  legalEntityId: PropTypes.string,
  loader: PropTypes.bool,
  permissions: PropTypes.any
};

export default LegalEntityInformationForm;
